/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 10:03:30
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-30 10:11:32
 * @name: 用户模块控制器
 * @Description: 用户模块控制器
 * @FilePath: \project\src\module\user\user.controller.js
 * @Author: desktop
 */
import { Controller, Get, Post, Validator } from "@/nestVue/common";
@Controller('user')
class userController {
  constructor() {

  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 内部登录
   * @param {Object} ctx 请求上下文
   */
  @Validator(require('./validator/login').validator, { toastError: true })
  @Post('login.html', { showLoading: true, })
  login(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 忘记重置密码
   * @param {Object} ctx 请求上下文
   */
  @Validator(require('./validator/forgetPwd').validator, { toastError: true })
  @Post('forgetPwd.html', { showLoading: true, toastSuccess: true, successMsg: '修改成功' })
  forgetPwd(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 退出登录
   * @param {Object} ctx 请求上下文
   */
  @Post('logout.html', { showLoading: true, })
  logout(ctx) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 注册
   * @param {Object} ctx 请求上下文
   */
  @Validator(require('./validator/register').validator, { toastError: true })
  @Post('register.html', { showLoading: true, toastSuccess: true, successMsg: '注册成功' })
  register(ctx) { }
}
export default userController;